import React from 'react';

export const hNow = {
    body: (
        <span>
            Historical volume from open until today&apos;s time now (averaged
            over the last 20 days).
        </span>
    ),
};

export const tNow = {
    body: (
        <span>
            Today&apos;s market volume from open until now expressed in shares.
        </span>
    ),
};

export const hDay = {
    body: (
        <span>
            Historical volume is the market historical traded volume (averaged
            over the last 20 days), expressed in shares. This includes
            continuous and auction trading.
        </span>
    ),
};

export const tDay = {
    body: (
        <span>
            Today&apos;s volume is the total traded volume + any remaining
            predicted volume, expressed in shares. This includes continuous and
            auction trading.
        </span>
    ),
};

export const hOpen = {
    body: (
        <span>
            Historical open is the market historical traded volume in the
            opening auction (averaged over the last 20 days) expressed in
            shares.
        </span>
    ),
};

export const hClose = {
    body: (
        <span>
            Historical close is the market historical traded volume in the
            closing auction (averaged over the last 20 days) expressed in
            shares.
        </span>
    ),
};

export const tRem = {
    body: (
        <span>
            The rest of today&apos;s predicted volume. This is the historical
            volume (averaged over the last 20 days) with today&apos;s
            adjustment.
        </span>
    ),
};

export const tClose = {
    body: (
        <span>
            Today&apos;s predicted traded volume in the closing auction.
        </span>
    ),
};

export const tAdj = {
    body: (
        <span>
            Today&apos;s adjustment is the % change in market volume today
            versus historical volume. It indicates if today&apos;s market volume
            is higher, lower or the same as the historical average. This value
            is used to predict the rest of day volume.
        </span>
    ),
};
